import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import { Pagination, Input, Form, Select, Row, Col, DatePicker, message } from 'antd';
import getHeaders from '../../utils/authHeaders';
import { dateConverter } from '../../utils/utcDateConversionCommon';
import { SearchBar } from '../../layouts/SearchBar';
import LoaderImage from '../LoaderImage';
import NoDataFound from '../../layouts/NoDataFound';
import ViewModal from './ViewModal';

const ShopPartnerRecordListing = () => {
  const [editbtn, setEditBtn] = useState('none');
  const [pageSize, setPageSize] = useState(10);
  const [pagesCount, setPagesCount] = useState(0);
  const [searchShow, setSearchShow] = useState({});
  const [renderList, setRenderList] = useState([]);
  const [tableShow, setTableShow] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [err, setErr] = useState('');
  // const [tableHeaders, setTableHeaders] = useState([]);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);

  // new states add:
  const [showAddModal, setShowAddModal] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [shopPartnerRecords, setShopPartnerRecords] = useState([]);

  const handleClose = () => setShow(false);
 
  let navigate = useNavigate();
  let convertedObj;

  const user = JSON.parse(localStorage.getItem('user'));
  if (user.userType === 'A') setEditBtn('block');

  
  const inventoryListingApi = async (formData) => {
    console.log('formData-->', formData);
    setLoader(true);

    const partnerResp = await axios.get(`${app.URL}/api/v1/admin/shoppartnerrecord/view?searchBy=${formData.searchBy}&limit=${formData.limit}&offset=${formData.offset}&searchTxt=${formData.searchTxt}`, { headers: getHeaders() });
    console.log('partnerResp---->', partnerResp);
    partnerResp ? console.log(partnerResp.data.result.data) : '';
    partnerResp ? (convertedObj = dateConverter(partnerResp.data.result.data.data, 'createdAt')) : ' ';
    partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
    partnerResp.data.result ? setRenderList(convertedObj) : ' ';
    partnerResp.data.result && setLoader(false);
    partnerResp.data.result.data.data && setIsRender(false);
  };

  const onChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setPageSize(pageSize);
    setCurrentPage(page);
    if (!page) page = 1;
    let limit = pageSize;
    try {
      let reqObj;
      if (Object.keys(searchShow).length !== 0) {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: searchShow.searchBy,
          searchTxt: searchShow.searchTxt,
        };
      } else {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: 'email',
          searchTxt: '',
        };
      }
      console.log(reqObj);
      await inventoryListingApi(reqObj);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.message);
      setTableShow(false);
    }
  };

  useEffect(() => {
    let formData = {
      limit: pageSize,
      offset: 0,
      searchBy: 'email',
      searchTxt: '',
    };
    inventoryListingApi(formData);
  }, [show]);

  let searchItems = [
    // {
    //   name: 'Registration ID',
    //   value: 'regId',
    // },
    {
      name: 'Email',
      value: 'email',
    },
    {
      name: 'Patient Name',
      value: 'patientName',
    },
    {
      name: 'Product Name',
      value: 'productName',
    },
  ];

  const onFinish = async (values) => {
    console.log('values-->', values);
    setSearchShow(values);
    let formData = {
      limit: 10,
      offset: 0,
      searchBy: values.searchBy,
      searchTxt: values.searchTxt,
    };
    if (!formData.searchTxt) message.error('Please enter search text');
    else await inventoryListingApi(formData);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  
  const handleOnChange = async (e) => {
    if (e.target.value.length === 0) {
      let formData = {
        limit: pageSize,
        offset: 0,
        searchBy: '',
        searchTxt: '',
      };
      setSearchShow({});
      await inventoryListingApi(formData);
    }
  };

  const viewPartnerRecord = async (regId) => {
    console.log('regId-->', regId);

    try {
      setShowAddModal(true);
      setModalLoader(true);
      const viewData = await axios.get(`${app.URL}/api/v1/admin/shoppartnerrecord/view/${regId}`, { headers: getHeaders() });
      console.log('viewData--->', viewData);
      viewData ? setShopPartnerRecords(viewData?.data?.result?.data) : '';

      setTimeout(() => {
        setModalLoader(false);
      }, 1000);
    } catch (error) {
      console.log(error);
    }

  };


  return (
    <>
      <ViewModal showAddModal={showAddModal} setShowAddModal={setShowAddModal} setIsRender={setIsRender} modalLoader={modalLoader} shopPartnerRecords={shopPartnerRecords} />

      <div className='dashboard-card container-fluid'>
        <div className='row p-0 pb-4'>
          <div className='for-before col-12 col-md-7 head fs-3 fw-bold' style={{ backgroundColor: '#a7c1d9', borderBottomRightRadius: '10px', color: '#FFFFFF' }}>
            Affiliate Records
          </div>
        </div>

        <SearchBar onFinish={onFinish} onFinishFailed={onFinishFailed} searchItems={searchItems} onChange={handleOnChange} />
        {/* <div style={{ display: 'none' }}>
          <div ref={printRef}>{displayQRCode.map((item) => item)}</div>
        </div> */}

        <div
          className='row table-scrollbar mr-0'
          style={{
            overflowX: 'auto',
          }}
        >
          {loader && <LoaderImage />}
          {renderList.length > 0 && !loader ? (
            <table id='customers'>
              <thead>
                <tr>
                  <th>Session ID</th>
                  <th>Email</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Date</th>
                  {/* <th>Partner</th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {renderList.map((tableValues) => (
                  <tr>
                    <td>{tableValues.sessionId !== null ? tableValues.sessionId : '-'}</td>

                    <td>{tableValues.shopPartnerEmail !== null ? tableValues.shopPartnerEmail : '-'}</td>
                    <td>{tableValues.firstName !== null ? tableValues.firstName : '-'}</td>
                    <td>{tableValues.lastName !== null ? tableValues.lastName : '-'}</td>
                    <td>{tableValues.createdAt !== null ? tableValues.createdAt : '-'}</td>
                    {/* <td>{tableValues.partnerName ? tableValues.partnerName : 'null'}</td> */}
                    <td>
                      <button className='btn text-light mx-2' onClick={() => viewPartnerRecord(tableValues.sessionId)}>
                        View{' '}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <>{!loader && <NoDataFound />}</>
          )}
        </div>
       

        <div className='row'>{currentPage && pagesCount ? <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={currentPage} total={pagesCount} showTotal={(total) => `Total ${total} items`} showSizeChanger /> : ' '}</div>
      </div>
    </>
  );
};

export default ShopPartnerRecordListing;
